export default __webpack_public_path__ + "static/media/PersonHold2.b06c3eec.svg";